<template>
  <div :class="['modal-backdrop', wrapperClasses]">
    <div class="modal" :style="modalStyling">
      <button v-if="showClose" class="modal-close" :disabled="disableAction" @click="$emit('close')">&times;</button>
      <slot name="title"></slot>
      <slot name="header"></slot>
      <slot name="body"></slot>
      <slot name="link"></slot>
      <button v-if="showActionButton" class="confirm button" :disabled="disableAction" @click="$emit('proceed')">{{buttonText}}</button>
      <div v-if="multiButtons" class="multi-buttons-container">
        <div
          v-for="(button, index) in multiButtons"
          :key="index"
          class="action-button-wrapper"
        >
          <div class="button" @click="$emit('action', button)">
            {{ button }}
          </div>
        </div>
      </div>
      <div
        v-if="showArrow"
        :class="['arrow', arrowConfig.arrowClasses]"
        :style="arrowConfig.arrowStyling"></div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Modal',
    props: {
      arrowConfig: {
        default: () => {},
        type: Object
      },
      buttonText: String,
      disableAction: {
        default: false,
        type: Boolean
      },
      ignoreKeyup: {
        default: false,
        type: Boolean
      },
      modalStyling: String,
      multiButtons: Array,
      showActionButton: {
        default: true,
        type: Boolean
      },
      showArrow: {
        default: false,
        type: Boolean
      },
      showClose: Boolean,
      wrapperClasses: [String, Array],
    },
    created() {
      window.addEventListener("keyup", this.onEscapeKeyUp);
    },
    methods: {
      onEscapeKeyUp(event) {
        if (event.which === 27 && !this.ignoreKeyup) {
          this.$emit("close");
        }
      }
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.modal-backdrop
  align-items: center
  background-color: rgba(0, 0, 0, 0.5)
  bottom: 0
  display: flex
  justify-content: center
  left: 0
  position: fixed
  right: 0
  top: 0
  z-index: 9

.modal
  background-color: white
  border: 2px solid $primary-color
  border-radius: 32px
  margin: 1em
  max-height: 90vh
  overflow: auto
  padding: 0.75em 
  position: relative

  .confirm
    border: none
    cursor: auto
    display: inline-block
    font-family: "AileronThin", Helvetica, Roboto, Arial, sans-serif
    outline: none
    position: relative
    right: auto
    &:after
      display: none
    &:disabled
      opacity: .5
    &:enabled
      cursor: pointer
  
  .arrow
    position: absolute
    width: 0
    height: 0

    &.up
      border-left: 5px solid transparent
      border-right: 5px solid transparent
      border-bottom: 5px solid $primary-color
      border-top: none

    &.down
      border-left: 5px solid transparent
      border-right: 5px solid transparent
      border-bottom: none
      border-top: 5px solid $primary-color

.modal-close
  background: none
  border: none
  color: $negative-color
  font-family: "AileronThin", Helvetica, Roboto, Arial, sans-serif
  font-size: 30px
  font-weight: lighter
  left: 20px
  line-height: 20px
  outline: none
  position: absolute
  top: 10px
  &:disabled
    opacity: .5
  &:enabled
    cursor: pointer
  &:hover:enabled
    color: $negative-hover

.sub-title
  margin: auto
  width: 70%

.performance-modal
  .modal
    border-radius: 30px
    max-width: 1000px
    padding: 15px

  .modal-close
    z-index: 1
    top: 10px !important

  .modal-header
    padding: 15px

    .grid-container
      margin-top: 20px

    .grid-content
      div
        padding: 0.75em 0 

  .modal-title
    font-size: 1.25em
    left: 0
    position: absolute
    top: 15px
    width: 100%
  
  .image-preview-wrapper
    max-height: 500px
    max-width: 100%

    img
      width: auto
      height: auto
      max-height: 500px
      max-width: 100%

  .link
    margin: 0
    position: absolute
    right: 15px
    top: 15px
    a
      color: $primary-color

.warning-modal
  .modal
    padding: 1rem 2rem

    .header
      font-size: 1.5rem
      padding: 2rem 0 1rem 0

  .confirm.button
    font-size: 1.25rem
    margin-top: 1rem
    padding: 1rem 2rem
    position: relative
    top: 50%

  &.error
    .modal
      border-color: $negative-hover

.image-preview-wrapper
  align-items: center
  display: flex
  flex-direction: column
  justify-content: center
  max-width: 850px

.cost-preview-wrapper
  align-items: center
  display: flex
  flex-direction: column
  justify-content: center
  margin-bottom: 3rem

  .title
    font-size: 1.5rem
    font-weight: bold
    padding: 1rem 0

  .sub-title
    font-size: 1.25rem
    padding: 0 0 1rem 0

  .max-cost
    margin: 1rem

  span
    font-weight: bold

table
  margin: 1rem auto 2rem auto
  text-align: left

  th, td
    padding: .75rem

  th
    font-weight: bold
</style>